import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import { actions } from '../categoria.actions'
import { CategoriaForm } from './CategoriaForm'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { Column } from 'primereact/column'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  const lookupCategoriaPai = {
    records: state.crudCategoriaState.records,
    columns: state.crudCategoriaState.columnsLookup
      .filter((col) => col.field === 'oid' || col.field === 'descricao')
      .map((col) => <Column key={col.field} {...col} />),
    first: state.crudCategoriaState.index,
    rows: state.crudCategoriaState.max,
    totalRecords: state.crudCategoriaState.count,
    sortField: state.crudCategoriaState.sortField,
    sortOrder: state.crudCategoriaState.sortOrder,
    editDisabled: false,
  }
  let lookupCategoria = Object.assign({}, state.crudCategoriaState.lookupCategoria, lookupCategoriaPai)

  return {
    record: state.crudCategoriaState.currentRecord,
    messages: state.crudCategoriaState.messages,
    lookupCategoria,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let value = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, value))
    },
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    lookupCategoriaSetVisible: (visible) => dispatch(actions.setLookupCategoriaVisible(visible)),
    lookupCategoriaPaginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    lookupCategoriaSortOrder: (sortParams) => {
      dispatch(actions.sortOrder(sortParams))
    },
    lookupCategoriaApplyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.setSelectedFilters(filterParams.campo, filterParams.valor))
      dispatch(actions.applyFilter(filterParams))
    },
    lookupCategoriaLoad: () => {
      dispatch(actions.setIndex(0))
      dispatch(actions.load(true))
      dispatch(actions.clearSelectedFilters())
    },
    setCategoria: (categoria) => {
      dispatch(actions.setField('categoriaPai.id', categoria != null ? categoria.oid : null))
      dispatch(actions.setField('categoriaPai.value', categoria != null ? categoria.descricao : ''))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    aplicarFiltrosPadraoCategoria: (categoria) => {
      let filtroRestricaoSemEspecialidade = {
        campo: 'categoriaPai.id',
        valor: null,
        tipoFiltro: 'NULO',
      }
      if (categoria && categoria.oid) {
        let novoFiltro = {
          campo: 'oid',
          valor: categoria.oid,
          tipoFiltro: 'DIFERENTE_DE',
        }
        dispatch(actions.setFiltroAvancado(novoFiltro))
      }
      dispatch(actions.setFiltroAvancado(filtroRestricaoSemEspecialidade))
    },
  }
}

class CategoriaFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
    }
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_CATEGORIA}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CATEGORIA}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CATEGORIA}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }
  componentWillUnmount() {
    this.props.clearSelectedFilters()
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CATEGORIA}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  lookupCategoriaOnPage = (e) => {
    this.props.aplicarFiltrosPadraoCategoria(this.props.record)
    this.props.lookupCategoriaPaginate({
      max: e.rows,
      index: e.first,
    })
  }

  lookupCategoriaOnSort = (e) => {
    this.props.aplicarFiltrosPadraoCategoria(this.props.record)
    this.props.lookupCategoriaSortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField,
      categoria: this.props.record,
    })
  }
  lookupCategoriaOnFilter = (e) => {
    let isFilterApplied = false
    this.props.aplicarFiltrosPadraoCategoria(this.props.record)
    const keys = Object.keys(e.filters) || []
    keys.forEach((key) => {
      const value = e.filters[key].value
      if (value) {
        let filter = {
          campo: key,
          valor: value,
          tipoFiltro: 'CONTEM',
        }
        this.props.lookupCategoriaApplyFilter(filter)
        isFilterApplied = true
      }
    })
    if (!isFilterApplied) {
      this.props.clearSelectedFilters()
      this.props.aplicarFiltrosPadraoCategoria(this.props.record)
      this.props.lookupCategoriaLoad(this.props.record)
    }
  }

  lookupCategoriaOnClick = (e) => {
    this.props.aplicarFiltrosPadraoCategoria(this.props.record)
    this.props.lookupCategoriaLoad(this.props.record)
    this.props.lookupCategoriaSetVisible(true)
  }

  lookupCategoriaOnHide = (e) => {
    this.props.lookupCategoriaSetVisible(false)
  }

  lookupCategoriaOnConfirm = (e) => {
    this.props.setCategoria(e.selection)
    this.props.lookupCategoriaSetVisible(false)
  }

  lookupCategoriaOnCancel = (e) => {
    this.props.setCategoria(null)
    this.props.lookupCategoriaSetVisible(false)
  }

  lookupCategoriaOnEdit = () => {
    if (this.props.record.categoriaPai && this.props.record.categoriaPai.id) {
      this.props.clearSelectedFilters()
      this.props.loadById(this.props.record.categoriaPai.id)
      return `${routes.PATH_CATEGORIA}/${this.props.record.categoriaPai.id}`
    } else {
      return `${routes.PATH_CATEGORIA}/`
    }
  }

  lookupCategoriaOnComplete = (e) => {}

  lookupCategoriaOnInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      const filter = {
        campo: 'descricao',
        valor: e.value,
        tipoFiltro: 'CONTEM',
      }
      this.props.aplicarFiltrosPadraoCategoria(this.props.currentRecord)
      this.props.setCategoria({ oid: null, descricao: e.value })
      this.props.lookupCategoriaApplyFilter(filter)
    } else {
      this.props.setCategoria(value)
    }
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <CategoriaForm
        record={this.props.record}
        changeHandler={this.props.changeHandler}
        messages={this.props.messages}
        history={this.props.history}
        lookupCategoria={this.props.lookupCategoria}
        lookupCategoriaOnHide={this.lookupCategoriaOnHide}
        lookupCategoriaOnConfirm={this.lookupCategoriaOnConfirm}
        lookupCategoriaOnCancel={this.lookupCategoriaOnCancel}
        lookupCategoriaOnPage={this.lookupCategoriaOnPage}
        lookupCategoriaOnSort={this.lookupCategoriaOnSort}
        lookupCategoriaOnFilter={this.lookupCategoriaOnFilter}
        lookupCategoriaOnClick={this.lookupCategoriaOnClick}
        lookupCategoriaOnEdit={this.lookupCategoriaOnEdit}
        lookupCategoriaOnComplete={this.lookupCategoriaOnComplete}
        lookupCategoriaOnInputFilter={this.lookupCategoriaOnInputFilter}
      />
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoriaFormPageContainer)
